export default __webpack_public_path__ + "ef6812e3c324f37d74dd1bd91d1509e3.svg";